<script setup lang="ts">
import { NxtFormSection } from '@future-harry/nxt-styles';
import SollicitantFormSection from '@/apps/admin/components/forms/settings/SollicitantFormSection.vue';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <NxtFormSection :title="$t('job-board.settings.sollicitants.title')">
      <SollicitantFormSection v-model="jobBoard.application_fields" />
   </NxtFormSection>
</template>
